import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import HistoriquePointages from './HistoriquePointages';
import PresenceDuJour from './PresenceDuJour';

/**
 * L'écran RH « Pointages » (Yros/Kavero#453) : « Présence du jour » y devient
 * l'onglet « Aujourd'hui », inchangé, à côté de « Historique et anomalies ».
 * L'historique ne se charge qu'à l'ouverture de son onglet.
 */
const ONGLETS = [
  { id: 'aujourdhui', Contenu: PresenceDuJour },
  { id: 'historique', Contenu: HistoriquePointages },
];

function Pointages() {
  const { t } = useTranslation();
  const [actif, setActif] = useState('aujourdhui');
  const { Contenu } = ONGLETS.find(({ id }) => id === actif);

  return (
    <div>
      <div role="tablist" className="flex gap-2 border-b border-slate-100 px-4 pt-4">
        {ONGLETS.map(({ id }) => (
          <button
            key={id}
            type="button"
            role="tab"
            data-testid={`pointages-onglet-${id}`}
            aria-selected={actif === id}
            onClick={() => setActif(id)}
            className={`rounded-t-lg px-4 py-2 text-sm font-medium ${actif === id
              ? 'border-b-2 border-[--color-primary] text-[--color-primary]'
              : 'text-slate-600 hover:bg-slate-50'}`}
          >
            {t(`pointagesRh.onglets.${id}`)}
          </button>
        ))}
      </div>
      <Contenu />
    </div>
  );
}

export default Pointages;
